import $ from 'jquery';

export default class Answers {
	constructor() {
		this.answersButton = $('.answers__button');
		this.buttonText = $('.answers__buttonText');
	}

	init() {
		this.answersButton.on('click', function (event) {
			event.preventDefault();

			const hiddenList = $(this).siblings().find('.answers-list__link-list');
			$(this).toggleClass('answers__button_open');
			hiddenList.toggleClass('answers-list__link-list_open');
			const buttonText = $(this).find('.answers__buttonText');
			if ($(this).hasClass('answers__button_open')) {
				buttonText.html('Свернуть');
			}else {
				buttonText.html('Показать все');
			}

			$(this).parent().each(function () {
				const array = [];
				let sum = 0;
				for (let i = 0; i < 3; i++) {
					array[i] = $(this).find('.answers-list__item').eq(i).outerHeight(true);
					sum += array[i];
				}
				$(this).find('.answers-list__link-list').height(sum);
				if ($(this).find('.answers-list__link-list').hasClass('answers-list__link-list_open')) {
					$(this).find('.answers-list__link-list').css('height', 'auto');
				}else {
					$(this).find('.answers-list__link-list').height(sum);
				}
			});
		});

	}
}



// WEBPACK FOOTER //
// ./app/blocks/answers/index.js